var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Import required dependencies at the top of your file
import firebase from "firebase/app";
import "firebase/firestore";
import { cancelBookingsOfTour } from "./cancelBookingsOfTour";
// This function deletes a tour and updates related tasks
function deleteTour(tour, setLoading, toaster) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var includedTasks, taskIds, batch;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    includedTasks = [];
                    tour.activities.forEach(function (activity) {
                        if (activity.id && !includedTasks.includes(activity.id)) {
                            includedTasks.push(activity.id);
                        }
                    });
                    taskIds = __spreadArray(__spreadArray([], includedTasks, true), ((_a = tour.tasksToAdd) !== null && _a !== void 0 ? _a : []), true);
                    if (!(tour.driver === "cure")) return [3 /*break*/, 2];
                    return [4 /*yield*/, cancelBookingsOfTour(includedTasks)];
                case 1:
                    _b.sent(); // Ensure this function is accessible
                    _b.label = 2;
                case 2:
                    batch = firebase.firestore().batch();
                    return [4 /*yield*/, Promise.all(taskIds.map(function (taskId) {
                            return new Promise(function (resolve, reject) {
                                firebase
                                    .firestore()
                                    .collection("tasks")
                                    .doc(taskId)
                                    .get()
                                    .then(function (doc) {
                                    if (!doc.exists)
                                        resolve();
                                    var input = {
                                        task_status: doc.data().task_prepared
                                            ? "prepared"
                                            : "unassigned",
                                        task_tour: null,
                                        mtBookingId: null,
                                        mtStatus: null,
                                    };
                                    var ref = firebase.firestore().collection("tasks").doc(taskId);
                                    batch.update(ref, input);
                                    resolve();
                                });
                            });
                        }))];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, batch.commit()];
                case 4:
                    _b.sent();
                    firebase
                        .firestore()
                        .collection("tours")
                        .doc(tour.id)
                        .delete()
                        .then(function () {
                        setLoading(false);
                        toaster.success("Tour wurde erfolgreich gelöscht");
                    })
                        .catch(function (err) {
                        setLoading(false);
                        console.error(err);
                        toaster.danger("Tour konnte nicht gelöscht werden");
                    });
                    return [2 /*return*/];
            }
        });
    });
}
export default deleteTour;
